import { render, staticRenderFns } from "./car-report-contract.vue?vue&type=template&id=38c09383"
import script from "./car-report-contract.vue?vue&type=script&lang=js"
export * from "./car-report-contract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports